import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SppdashboardService } from '../dashboard/sppdashboard.service';

@Component({
  selector: 'app-courseware',
  templateUrl: './courseware.component.html',
  standalone: false,
  styleUrl: './courseware.component.scss'
})
export class CoursewareComponent {

  constructor(private router: Router, private sppdashboardService: SppdashboardService,) { }


  ngOnInit() {
    window.open("https://learningdownloadcenter.microsoft.com/welcome", '_blank')
    this.router.navigate(['/home']);
  }

}
